import React from "react";
import { CustomIcon } from "../../../UI";
import "./StepSelector.scss";

const StepSelector = ({ currentStep = 1, onStepClick }) => {
  const steps = [
    { id: 1, name: "Customer", icon: "users" },
    { id: 2, name: "Shipment", icon: "truckon" },
    { id: 3, name: "Pickup", icon: "marker-02" },
    { id: 4, name: "Delivery", icon: "marker-02" },
    { id: 5, name: "Carrier", icon: "person" },
  ];

  return (
    <div className="step-selector">
      <div className="steps-container">
        {steps.map((step, index) => {
          const isCompleted = step.id < currentStep;
          const isActive = step.id === currentStep;
          const isPending = step.id > currentStep;

          return (
            <React.Fragment key={step.id}>
              {/* Step Circle */}
              <div
                className={`step-circle ${isCompleted ? "completed" : ""} ${
                  isActive ? "active" : ""
                } ${isPending ? "pending" : ""}`}
                onClick={() => onStepClick && onStepClick(step.id)}
              >
                {isCompleted ? (
                  <div>
                    <CustomIcon name="check" size={20}  type="svg" />
                    <div className={`step-label ${isActive ? "active" : ""}`}>
                      {step.name}
                    </div>
                  </div>
                ) : (
                  <div>
                    <CustomIcon
                      type="svg"  
                      name={step.icon}
                      size={20}
                    />
                      {/* <img
                      src={step.icon}
                      alt={step.name}
                      className={`step-icon ${isActive ? "active" : ""}`}
                    /> */}
                    <div className={`step-label ${isActive ? "active" : ""}`}>
                      {step.name}
                    </div>
                  </div>
                )}
              </div>

              {/* Step Label */}

              {/* Connector Line */}
              {index < steps.length - 1 && (
                <div
                  className={`connector-line ${
                    isCompleted ? "completed" : ""
                  } ${isActive ? "active" : ""}`}
                />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default StepSelector;
